module.exports = __webpack_public_path__ + "img/login-art-5.8878fc8.jpg";